import angular from 'angular';
import paymentOrdersComponent from './payment-orders.component';
import paymentOrdersService from './payment-orders.service';
import paymentOrdersConfig from './payment-orders.config';

let paymentOrdersModule = angular.module('app.paymentOrders',[])
  .component('paymentOrders', paymentOrdersComponent)
  .service('PaymentOrdersService', paymentOrdersService)
  .config(paymentOrdersConfig);

export default paymentOrdersModule;



/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/payments-advances/payment-orders/payment-orders.js
 **/